import styled from 'styled-components';

export const StyledFormsTemplatesListItemPlaceholderName = styled.span`
   color: ${(props) => props.theme.disabled};
   font-style: italic;
`;
StyledFormsTemplatesListItemPlaceholderName.displayName = 'StyledFormsTemplatesListItemPlaceholderName';
